import {
  faChartSimple,
  faChevronUp,
  faUserGraduate
} from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type { ReactElement } from 'react'
import { useId, useState } from 'react'
import { Tooltip } from '~/components/Global/Elements/Tooltip/Tooltip'
import {
  Button,
  ButtonVariation
} from '~/components/Global/Interactions/Button'
import {
  HeaderActions,
  HeaderIcon,
  HeaderTitle,
  PageHeader
} from '~/components/Layout/Page'
import { ApplicationsKpis } from '~/domains/applications/components/ApplicationsKpis'

const STORAGE_KEY = 'applications.kpisCollapsed'

export const Header = (): ReactElement => {
  const kpisId = useId()
  const [collapsed, setCollapsed] = useState<boolean>(
    () => localStorage.getItem(STORAGE_KEY) === 'true'
  )

  const toggleCollapsed = () => {
    setCollapsed((prev) => {
      const next = !prev
      localStorage.setItem(STORAGE_KEY, String(next))
      return next
    })
  }

  const toggleLabel = collapsed
    ? 'Afficher les statistiques'
    : 'Masquer les statistiques'

  return (
    <PageHeader
      footer={
        !collapsed && (
          <div id={kpisId}>
            <ApplicationsKpis />
          </div>
        )
      }
    >
      <HeaderTitle>
        <HeaderIcon icon={faUserGraduate} />
        Candidatures
      </HeaderTitle>
      <HeaderActions>
        <Tooltip text={toggleLabel} direction="bottom" asChild>
          <Button
            variation={ButtonVariation.Neutral}
            buttonSize="small"
            narrow
            onClick={toggleCollapsed}
            aria-label={toggleLabel}
            aria-expanded={!collapsed}
            aria-controls={collapsed ? undefined : kpisId}
          >
            <FontAwesomeIcon icon={collapsed ? faChartSimple : faChevronUp} />
          </Button>
        </Tooltip>
      </HeaderActions>
    </PageHeader>
  )
}
